import React, { useEffect, useState } from 'react'
import { merge } from 'lodash'
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Descriptions,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table
} from 'antd'
import BACK_NECK from '../assets/FFA-Cambridge1.png'
import SLEEVE_LENGTH from '../assets/FFA-Cambridge2.png'
import FINISHED_INLEG_LENGTHS from '../assets/FFA-Cambridge3.png'
import WAIST from '../assets/FFA-Cambridge4.png'
import SILK_SADDLE from '../assets/FFA-Cambridge5.png'
import SHORTERN_SLEEVE_LENGTH from '../assets/FFA-Ganton1.png'
import CHANGE_CUFF from '../assets/FFA-Ganton2.png'
import ADD_REMOVE_POCKET from '../assets/FFA-Ganton3.png'
import { isGantonTemplate } from '../util'

export const ViewAlterationsModal = props => {
  const { alterationFields, orderItem, requestingStore } = props
  const [isModalOpen, setIsModalOpen] = useState(false)

  const gantonTemplateFlag = isGantonTemplate(requestingStore)
  
  const hasValue = v => v !== null && v !== undefined && v !== ''
  
  const formatMeasurement = (value, emptyLabel = 'Not specified') =>
    hasValue(value) ? value === '0' ? `${value} cm (No alteration)` : `${value} cm` : emptyLabel

  const cambridgeReviewItems = [
    hasValue(alterationFields?.backNeck) && { key: 'backNeck', label: 'Back Neck', children: formatMeasurement(alterationFields?.backNeck, 'Not changed') },
    hasValue(alterationFields?.sleeveLength?.left) && { key: 'sleeveLengthLeft', label: 'Sleeve Length (Left)', children: formatMeasurement(alterationFields?.sleeveLength?.left) },
    hasValue(alterationFields?.sleeveLength?.right) && { key: 'sleeveLengthRight', label: 'Sleeve Length (Right)', children: formatMeasurement(alterationFields?.sleeveLength?.right) },
    hasValue(alterationFields?.finishedInlegLengths?.left) && { key: 'inlegLeft', label: 'In-leg Length (Left)', children: formatMeasurement(alterationFields?.finishedInlegLengths?.left) },
    hasValue(alterationFields?.finishedInlegLengths?.right) && { key: 'inlegRight', label: 'In-leg Length (Right)', children: formatMeasurement(alterationFields?.finishedInlegLengths?.right) },
    hasValue(alterationFields?.waist) && { key: 'waist', label: 'Waist', children: formatMeasurement(alterationFields?.waist, 'Not changed') },
    { key: 'silkSaddle', label: 'Silk Saddle', children: alterationFields?.silkSaddle ? 'Yes' : 'No' },
    hasValue(alterationFields?.comments) && { key: 'comments', label: 'Comments', children: alterationFields?.comments }
  ].filter(item => item)

  const gantonReviewItems = [
    hasValue(alterationFields?.shortenSleeveLength?.left) && { key: 'shortenLeft', label: 'Shorten Sleeve (Left)', children: formatMeasurement(alterationFields?.shortenSleeveLength?.left, 'Not changed') },
    hasValue(alterationFields?.shortenSleeveLength?.leftMeasurement) && { key: 'shortenLeftMeasurement', label: 'Left Finished Measurement', children: formatMeasurement(alterationFields?.shortenSleeveLength?.leftMeasurement) },
    hasValue(alterationFields?.shortenSleeveLength?.right) && { key: 'shortenRight', label: 'Shorten Sleeve (Right)', children: formatMeasurement(alterationFields?.shortenSleeveLength?.right, 'Not changed') },
    hasValue(alterationFields?.shortenSleeveLength?.rightMeasurement) && { key: 'shortenRightMeasurement', label: 'Right Finished Measurement', children: formatMeasurement(alterationFields?.shortenSleeveLength?.rightMeasurement) },
    { key: 'changeCuff', label: 'Change Cuff', children: alterationFields?.changeCuff || 'None' },
    { key: 'addRemovePocket', label: 'Add / Remove Pocket', children: alterationFields?.addRemovePocket || 'None' },
    { key: 'neckSize', label: 'Neck Size', children: formatMeasurement(alterationFields?.neckSize) },
    hasValue(alterationFields?.comments) && { key: 'comments', label: 'Comments', children: alterationFields?.comments }
  ].filter(item => item)

  const reviewItems = gantonTemplateFlag ? gantonReviewItems : cambridgeReviewItems

  return (
    <>
      <Button type="link" onClick={() => setIsModalOpen(true)} style={{ padding: 0 }}>
        Yes
      </Button>
      <Modal
        width={800}
        title={`Alterations - Product Code: ${
          orderItem?.productCode?.toUpperCase() || ''
        }, Size: ${orderItem?.size || ''}, Colour: ${orderItem?.colour || ''}`}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key='close' type='primary' onClick={() => setIsModalOpen(false)}>
            Close
          </Button>
        ]}
      >
        <p>Review the alteration details below.</p>
        <Descriptions bordered column={1} size='small'>
          {reviewItems.map(item => (
            <Descriptions.Item key={item.key} label={item.label}>
              {item.children}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Modal>
    </>
  )
}

const ChangeCuff = props => {
  const { index, dataIndex, modalData, setModalData } = props
  const handleClick = changeCuffName => () => {
    setModalData(pre => {
      return {
        ...pre,
        changeCuff: pre?.changeCuff === changeCuffName ? '' : changeCuffName
      }
    })
  }
  return (
    <>
      <Form.Item name={[index, dataIndex, 'changeCuff']}>
        <Checkbox
          checked={modalData?.changeCuff === 'Button Cuff'}
          onClick={handleClick('Button Cuff')}
        >
          Button Cuff
        </Checkbox>
      </Form.Item>
      <Form.Item name={[index, dataIndex, 'changeCuff']}>
        <Checkbox
          checked={modalData?.changeCuff === 'French Cuff'}
          onClick={handleClick('French Cuff')}
        >
          French Cuff
        </Checkbox>
      </Form.Item>
      <div style={{ fontSize: '12px' }}>
        Change cuff alteration only available on select styles.
      </div>
    </>
  )
}

const ChangePocket = props => {
  const { index, dataIndex, modalData, setModalData } = props
  const handleClick = addRemovePocket => () => {
    setModalData(pre => {
      return {
        ...pre,
        addRemovePocket:
          pre?.addRemovePocket === addRemovePocket ? '' : addRemovePocket
      }
    })
  }

  return (
    <>
      <Form.Item name={[index, dataIndex, 'addRemovePocket']}>
        <Checkbox
          checked={modalData?.addRemovePocket === 'Add Pocket'}
          onClick={handleClick('Add Pocket')}
        >
          Add Pocket
        </Checkbox>
      </Form.Item>
      <Form.Item name={[index, dataIndex, 'addRemovePocket']}>
        <Checkbox
          checked={modalData?.addRemovePocket === 'Remove Pocket'}
          onClick={handleClick('Remove Pocket')}
        >
          Remove Pocket
        </Checkbox>
      </Form.Item>

      <div style={{ fontSize: '12px' }}>
        Adding pocket alteration only available on select styles.
      </div>
    </>
  )
}

const AddAlterationsFormModal = props => {
  const { index, dataIndex, form } = props

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [step, setStep] = useState(0)
  const [errors, setErrors] = useState([])

  const requestingStore = form.getFieldValue('requestingStore')
  const gantonTemplateFlag = isGantonTemplate(requestingStore)
  const orderItem = form.getFieldValue(['orders', index])
  const alterationFields = Form.useWatch(
    ['orders', index, 'alterationFields'],
    form
  )

  const [modalData, setModalData] = useState(alterationFields)

  const hasValue = v => v !== null && v !== undefined && v !== ''

  const validateAlterations = () => {
    const newErrors = []

    if (!gantonTemplateFlag) {
      const leftSleeve = alterationFields?.sleeveLength?.left || modalData?.sleeveLength?.left
      const rightSleeve = alterationFields?.sleeveLength?.right || modalData?.sleeveLength?.right
      if (hasValue(leftSleeve) !== hasValue(rightSleeve)) {
        newErrors.push(
          'Both left and right sleeve measurements must be filled out. Enter 0 if no alteration is needed for one side.'
        )
      }
      if (hasValue(leftSleeve) && parseInt(leftSleeve, 10) !== 0 && (parseInt(leftSleeve, 10) < 45 || parseInt(leftSleeve, 10) > 75)) {
        newErrors.push('Left sleeve measurement must be between 45 and 75 cm, or 0 cm for no alteration.')
      }
      if (hasValue(rightSleeve) && parseInt(rightSleeve, 10) !== 0 && (parseInt(rightSleeve, 10) < 45 || parseInt(rightSleeve, 10) > 75)) {
        newErrors.push('Right sleeve measurement must be between 45 and 75 cm, or 0 cm for no alteration.')
      }

      const leftInleg = alterationFields?.finishedInlegLengths?.left || modalData?.finishedInlegLengths?.left
      const rightInleg = alterationFields?.finishedInlegLengths?.right || modalData?.finishedInlegLengths?.right
      if (hasValue(leftInleg) !== hasValue(rightInleg)) {
        newErrors.push(
          'Both left and right in-leg measurements must be filled out. Enter 0 if no alteration is needed for one side.'
        )
      }
      if (hasValue(leftInleg) && parseInt(leftInleg, 10) !== 0 && (parseInt(leftInleg, 10) < 55 || parseInt(leftInleg, 10) > 90)) {
        newErrors.push('Left in-leg length must be between 55 and 90 cm, or 0 cm for no alteration.')
      }
      if (hasValue(rightInleg) && parseInt(rightInleg, 10) !== 0 && (parseInt(rightInleg, 10) < 55 || parseInt(rightInleg, 10) > 90)) {
        newErrors.push('Right in-leg length must be between 55 and 90 cm, or 0 cm for no alteration.')
      }
    } else {
      const leftSleeve = alterationFields?.shortenSleeveLength?.left || modalData?.shortenSleeveLength?.left
      const rightSleeve = alterationFields?.shortenSleeveLength?.right || modalData?.shortenSleeveLength?.right
      if (hasValue(leftSleeve) !== hasValue(rightSleeve)) {
        newErrors.push(
          'Both left and right sleeve must be selected. Choose 0.00 cm from the dropdown if no alteration is needed for one side.'
        )
      }
    }

    return newErrors
  }

  const showModal = () => {
    setStep(0)
    setErrors([])
    setIsModalOpen(true)
  }

  const handleOk = () => {
    if (step === 0) {
      const validationErrors = validateAlterations()
      if (validationErrors.length > 0) {
        setErrors(validationErrors)
        return
      }
      setErrors([])
      setStep(1)
    } else {
      const mergedData = merge(alterationFields, modalData)
      form.setFieldValue(['orders', index, dataIndex], mergedData)
      form.setFieldValue(
        ['orders', index, 'alterations'],
        `${orderItem?.productCode}-${orderItem?.orderItemId}`
      )
      // mark form as confirmed
      form.setFieldValue(['orders', index, 'alterationFieldsConfirmed'], true)
      setIsModalOpen(false)
      setStep(0)
      setErrors([])
    }
  }

  const handleCancel = () => {
    setModalData(alterationFields)
    setIsModalOpen(false)
    setStep(0)
    setErrors([])
  }

  const cambridgeColumns = [
    {
      title: 'Back Neck',
      dataIndex: 'backNeck',
      key: 'backNeck',
      width: '20%'
    },
    {
      title: 'Sleeve Length',
      dataIndex: 'sleeveLength',
      key: 'sleeveLength',
      width: '20%'
    },
    {
      title: 'Finished In-leg Lengths',
      dataIndex: 'finishedInlegLengths',
      key: 'finishedInlegLengths',
      width: '20%'
    },
    {
      title: 'Waist',
      dataIndex: 'waist',
      key: 'waist',
      width: '20%'
    },
    {
      title: 'Silk Saddle',
      dataIndex: 'silkSaddle',
      key: 'silkSaddle',
      width: '20%'
    }
  ]

  const jacketDisabled =
    modalData?.finishedInlegLengths?.left ||
    alterationFields?.finishedInlegLengths?.left ||
    modalData?.finishedInlegLengths?.right ||
    alterationFields?.finishedInlegLengths?.right ||
    Math.ceil(Math.abs(modalData?.waist)) ||
    Math.ceil(Math.abs(alterationFields?.waist)) ||
    modalData?.silkSaddle ||
    alterationFields?.silkSaddle
  const trouserDisabled =
    Math.ceil(Math.abs(modalData?.backNeck)) ||
    Math.ceil(Math.abs(alterationFields?.backNeck)) ||
    modalData?.sleeveLength?.left ||
    alterationFields?.sleeveLength?.left ||
    modalData?.sleeveLength?.right ||
    alterationFields?.sleeveLength?.right

  const cambridgeDataSource = [
    {
      key: 1,
      backNeck: (
        <img
          src={BACK_NECK}
          alt=''
          style={{ maxWidth: '10rem', height: 'auto' }}
        />
      ),
      sleeveLength: (
        <img
          src={SLEEVE_LENGTH}
          alt=''
          style={{ maxWidth: '10rem', height: 'auto' }}
        />
      ),
      finishedInlegLengths: (
        <img
          src={FINISHED_INLEG_LENGTHS}
          alt=''
          style={{ maxWidth: '10rem', height: 'auto' }}
        />
      ),
      waist: (
        <img src={WAIST} alt='' style={{ maxWidth: '10rem', height: 'auto' }} />
      ),
      silkSaddle: (
        <img
          src={SILK_SADDLE}
          alt=''
          style={{ maxWidth: '10rem', height: 'auto' }}
        />
      )
    },
    {
      key: 2,
      backNeck: (
        <Form.Item name={[index, dataIndex, 'backNeck']}>
          <Space>
            <Select
              style={{ width: '5rem' }}
              disabled={jacketDisabled}
              value={modalData?.backNeck || alterationFields?.backNeck}
              onChange={value => {
                setModalData(pre => ({ ...pre, backNeck: value }))
              }}
            >
              <Select.Option value='0.00'>0.00</Select.Option>
              <Select.Option value='-0.5'>-0.5</Select.Option>
              <Select.Option value='-1.0'>-1.0</Select.Option>
            </Select>
            <strong>cm</strong>
          </Space>
        </Form.Item>
      ),
      sleeveLength: (
        <>
          <Form.Item name={[index, dataIndex, 'sleeveLength', 'left']}>
            <Space>
              <InputNumber
                disabled={jacketDisabled}
                min={0}
                max={75}
                value={
                  modalData?.sleeveLength?.left ||
                  alterationFields?.sleeveLength?.left
                }
                onChange={value => {
                  setModalData(pre => ({
                    ...pre,
                    sleeveLength: { ...pre?.sleeveLength, left: value }
                  }))
                }}
              />
              <div style={{ width: '10rem' }}>
                <strong>cm</strong> Left Sleeve Measurement
              </div>
            </Space>
          </Form.Item>
          <Form.Item name={[index, dataIndex, 'sleeveLength', 'right']}>
            <Space>
              <InputNumber
                disabled={jacketDisabled}
                min={0}
                max={75}
                value={
                  modalData?.sleeveLength?.right ||
                  alterationFields?.sleeveLength?.right
                }
                onChange={value => {
                  setModalData(pre => ({
                    ...pre,
                    sleeveLength: { ...pre?.sleeveLength, right: value }
                  }))
                }}
              />
              <div style={{ width: '10rem' }}>
                <strong>cm</strong> Right Sleeve Measurement
              </div>
            </Space>
          </Form.Item>
          <div style={{ fontSize: '12px' }}>Maximum added length +4cm.</div>
          <div style={{ fontSize: '12px' }}>Measure from shoulder to cuff.</div>
        </>
      ),
      finishedInlegLengths: (
        <>
          <Form.Item name={[index, dataIndex, 'finishedInlegLengths', 'left']}>
            <Space>
              <InputNumber
                disabled={trouserDisabled}
                min={0}
                max={90}
                value={
                  modalData?.finishedInlegLengths?.left ||
                  alterationFields?.finishedInlegLengths?.left
                }
                onChange={value => {
                  setModalData(pre => ({
                    ...pre,
                    finishedInlegLengths: {
                      ...pre?.finishedInlegLengths,
                      left: value
                    }
                  }))
                }}
              />
              <div style={{ width: '10rem' }}>
                <strong>cm</strong> Left In-leg Measurement
              </div>
            </Space>
          </Form.Item>
          <Form.Item name={[index, dataIndex, 'finishedInlegLengths', 'right']}>
            <Space>
              <InputNumber
                disabled={trouserDisabled}
                min={0}
                max={90}
                value={
                  modalData?.finishedInlegLengths?.right ||
                  alterationFields?.finishedInlegLengths?.right
                }
                onChange={value => {
                  setModalData(pre => ({
                    ...pre,
                    finishedInlegLengths: {
                      ...pre?.finishedInlegLengths,
                      right: value
                    }
                  }))
                }}
              />
              <div style={{ width: '10rem' }}>
                <strong>cm</strong> Right In-leg Measurement
              </div>
            </Space>
          </Form.Item>
          <div style={{ fontSize: '12px' }}>Maximum length +4cm (90cm).</div>
          <div style={{ fontSize: '12px' }}>Measure from top to bottom.</div>
        </>
      ),
      waist: (
        <>
          <Form.Item name={[index, dataIndex, 'waist']}>
            <Space>
              <Select
                disabled={trouserDisabled}
                placement='topRight'
                style={{ width: '5rem' }}
                value={modalData?.waist || alterationFields?.waist}
                onChange={value => {
                  setModalData(pre => ({ ...pre, waist: value }))
                }}
              >
                <Select.Option value='+4.00'>+4.00</Select.Option>
                <Select.Option value='+3.00'>+3.00</Select.Option>
                <Select.Option value='+2.00'>+2.00</Select.Option>
                <Select.Option value='+1.00'>+1.00</Select.Option>
                <Select.Option value='0.00'>0.00</Select.Option>
                <Select.Option value='-1.00'>-1.00</Select.Option>
                <Select.Option value='-2.00'>-2.00</Select.Option>
                <Select.Option value='-3.00'>-3.00</Select.Option>
                <Select.Option value='-4.00'>-4.00</Select.Option>
              </Select>
              <strong>cm</strong>
            </Space>
          </Form.Item>
          <div style={{ fontSize: '12px' }}>
            *Waist = ticket/soft tag waist size
          </div>
        </>
      ),
      silkSaddle: (
        <Form.Item name={[index, dataIndex, 'silkSaddle']}>
          <Checkbox
            style={{ width: '9rem' }}
            disabled={trouserDisabled}
            checked={modalData?.silkSaddle}
            onChange={e => {
              setModalData(pre => ({ ...pre, silkSaddle: e.target.checked }))
            }}
          >
            Add silk saddle
          </Checkbox>
        </Form.Item>
      )
    }
  ]
  const gantonColumns = [
    {
      title: 'Shorten Sleeve Length',
      dataIndex: 'shortenSleeveLength',
      key: 'shortenSleeveLength',
      width: '40%'
    },
    {
      title: 'Change Cuff',
      dataIndex: 'changeCuff',
      key: 'changeCuff',
      width: '30%'
    },
    {
      title: 'Add / Remove Pocket',
      dataIndex: 'addRemovePocket',
      key: 'addRemovePocket',
      width: '30%'
    }
  ]
  const gantonDataSource = [
    {
      key: 1,
      shortenSleeveLength: (
        <img
          src={SHORTERN_SLEEVE_LENGTH}
          alt=''
          style={{ maxWidth: '15rem', height: 'auto' }}
        />
      ),
      changeCuff: (
        <img
          src={CHANGE_CUFF}
          alt=''
          style={{ maxWidth: '15rem', height: 'auto' }}
        />
      ),
      addRemovePocket: (
        <img
          src={ADD_REMOVE_POCKET}
          alt=''
          style={{ maxWidth: '15rem', height: 'auto' }}
        />
      )
    },
    {
      key: 2,
      shortenSleeveLength: (
        <>
          <Row>
            <Col span={12}>
              <Form.Item
                name={[index, dataIndex, 'shortenSleeveLength', 'left']}
              >
                <Space>
                  <Select
                    style={{ width: '5rem' }}
                    value={
                      modalData?.shortenSleeveLength?.left ||
                      alterationFields?.shortenSleeveLength?.left
                    }
                    onChange={value => {
                      setModalData(pre => ({
                        ...pre,
                        shortenSleeveLength: {
                          ...pre?.shortenSleeveLength,
                          left: value
                        }
                      }))
                    }}
                  >
                    <Select.Option value='0.00'>0.00</Select.Option>
                    <Select.Option value='-1.0'>-1.0</Select.Option>
                    <Select.Option value='-2.0'>-2.0</Select.Option>
                  </Select>
                  <span>
                    <strong>cm</strong> Left
                  </span>
                </Space>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name={[
                  index,
                  dataIndex,
                  'shortenSleeveLength',
                  'leftMeasurement'
                ]}
              >
                <Space>
                  <InputNumber
                    min={0}
                    value={
                      modalData?.shortenSleeveLength?.leftMeasurement ||
                      alterationFields?.shortenSleeveLength?.leftMeasurement
                    }
                    onChange={value =>
                      setModalData(pre => ({
                        ...pre,
                        shortenSleeveLength: {
                          ...pre?.shortenSleeveLength,
                          leftMeasurement: value
                        }
                      }))
                    }
                  />
                  <span>
                    <strong>cm</strong> Finished Measurement
                  </span>
                </Space>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                name={[index, dataIndex, 'shortenSleeveLength', 'right']}
              >
                <Space>
                  <Select
                    style={{ width: '5rem' }}
                    value={
                      modalData?.shortenSleeveLength?.right ||
                      alterationFields?.shortenSleeveLength?.right
                    }
                    onChange={value =>
                      setModalData(pre => ({
                        ...pre,
                        shortenSleeveLength: {
                          ...pre?.shortenSleeveLength,
                          right: value
                        }
                      }))
                    }
                  >
                    <Select.Option value='0.00'>0.00</Select.Option>
                    <Select.Option value='-1.0'>-1.0</Select.Option>
                    <Select.Option value='-2.0'>-2.0</Select.Option>
                  </Select>
                  <span>
                    <strong>cm</strong> Right
                  </span>
                </Space>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name={[
                  index,
                  dataIndex,
                  'shortenSleeveLength',
                  'rightMeasurement'
                ]}
              >
                <Space>
                  <InputNumber
                    min={0}
                    value={
                      modalData?.shortenSleeveLength?.rightMeasurement ||
                      alterationFields?.shortenSleeveLength?.rightMeasurement
                    }
                    onChange={value =>
                      setModalData(pre => ({
                        ...pre,
                        shortenSleeveLength: {
                          ...pre?.shortenSleeveLength,
                          rightMeasurement: parseInt(value)
                        }
                      }))
                    }
                  />
                  <span>
                    <strong>cm</strong> Finished Measurement
                  </span>
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
      changeCuff: (
        <ChangeCuff
          modalData={modalData}
          index={index}
          dataIndex={dataIndex}
          setModalData={setModalData}
        />
      ),
      addRemovePocket: (
        <ChangePocket
          modalData={modalData}
          index={index}
          dataIndex={dataIndex}
          setModalData={setModalData}
        />
      )
    }
  ]

  const formatMeasurement = (value, emptyLabel = 'Not specified') =>
    hasValue(value) ? value === '0' ? `${value} cm (No alteration)` : `${value} cm` : emptyLabel

  const cambridgeReviewItems = [
    hasValue(modalData?.backNeck || alterationFields?.backNeck) && { key: 'backNeck', label: 'Back Neck', children: formatMeasurement(modalData?.backNeck || alterationFields?.backNeck, 'Not changed') },
    hasValue(modalData?.sleeveLength?.left || alterationFields?.sleeveLength?.left) && { key: 'sleeveLengthLeft', label: 'Sleeve Length (Left)', children: formatMeasurement(modalData?.sleeveLength?.left || alterationFields?.sleeveLength?.left) },
    hasValue(modalData?.sleeveLength?.right || alterationFields?.sleeveLength?.right) && { key: 'sleeveLengthRight', label: 'Sleeve Length (Right)', children: formatMeasurement(modalData?.sleeveLength?.right || alterationFields?.sleeveLength?.right) },
    hasValue(modalData?.finishedInlegLengths?.left || alterationFields?.finishedInlegLengths?.left) && { key: 'inlegLeft', label: 'In-leg Length (Left)', children: formatMeasurement(modalData?.finishedInlegLengths?.left || alterationFields?.finishedInlegLengths?.left) },
    hasValue(modalData?.finishedInlegLengths?.right || alterationFields?.finishedInlegLengths?.right) && { key: 'inlegRight', label: 'In-leg Length (Right)', children: formatMeasurement(modalData?.finishedInlegLengths?.right || alterationFields?.finishedInlegLengths?.right) },
    hasValue(modalData?.waist || alterationFields?.waist) && { key: 'waist', label: 'Waist', children: formatMeasurement(modalData?.waist || alterationFields?.waist, 'Not changed') },
    { key: 'silkSaddle', label: 'Silk Saddle', children: modalData?.silkSaddle ? 'Yes' : 'No' },
    hasValue(modalData?.comments || alterationFields?.comments) && { key: 'comments', label: 'Comments', children: modalData?.comments || alterationFields?.comments }
  ].filter(item => item)

  const gantonReviewItems = [
    hasValue(modalData?.shortenSleeveLength?.left || alterationFields?.shortenSleeveLength?.left) && { key: 'shortenLeft', label: 'Shorten Sleeve (Left)', children: formatMeasurement(modalData?.shortenSleeveLength?.left || alterationFields?.shortenSleeveLength?.left, 'Not changed') },
    hasValue(modalData?.shortenSleeveLength?.leftMeasurement || alterationFields?.shortenSleeveLength?.leftMeasurement) && { key: 'shortenLeftMeasurement', label: 'Left Finished Measurement', children: formatMeasurement(modalData?.shortenSleeveLength?.leftMeasurement || alterationFields?.shortenSleeveLength?.leftMeasurement) },
    hasValue(modalData?.shortenSleeveLength?.right || alterationFields?.shortenSleeveLength?.right) && { key: 'shortenRight', label: 'Shorten Sleeve (Right)', children: formatMeasurement(modalData?.shortenSleeveLength?.right || alterationFields?.shortenSleeveLength?.right, 'Not changed') },
    hasValue(modalData?.shortenSleeveLength?.rightMeasurement || alterationFields?.shortenSleeveLength?.rightMeasurement) && { key: 'shortenRightMeasurement', label: 'Right Finished Measurement', children: formatMeasurement(modalData?.shortenSleeveLength?.rightMeasurement || alterationFields?.shortenSleeveLength?.rightMeasurement) },
    { key: 'changeCuff', label: 'Change Cuff', children: modalData?.changeCuff || 'None' },
    { key: 'addRemovePocket', label: 'Add / Remove Pocket', children: modalData?.addRemovePocket || 'None' },
    { key: 'neckSize', label: 'Neck Size', children: formatMeasurement(modalData?.neckSize) },
    hasValue(modalData?.comments || alterationFields?.comments) && { key: 'comments', label: 'Comments', children: modalData?.comments || alterationFields?.comments }
  ].filter(item => item)

  const reviewItems = gantonTemplateFlag ? gantonReviewItems : cambridgeReviewItems

  const modalFooter = [
    step === 1 && (
      <Button key='back' onClick={() => setStep(0)}>
        Back
      </Button>
    ),
    <Button key='cancel' onClick={handleCancel}>
      Cancel
    </Button>,
    <Button key='ok' type='primary' onClick={handleOk}>
      {step === 0 ? 'Next' : 'Confirm'}
    </Button>
  ].filter(Boolean)

  const alterationFieldsConfirmed = form.getFieldValue(['orders', index, 'alterationFieldsConfirmed'])

  return (
    <>
      <Button onClick={showModal}>{alterationFieldsConfirmed ? 'Edit' : 'Add'}</Button>
      <Modal
        width={2000}
        maskClosable={false}
        title={`Product Code: ${
          orderItem?.productCode?.toUpperCase() || ''
        }, Size: ${orderItem?.size || ''}, Colour: ${orderItem?.colour || ''}`}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={modalFooter}
      >
        {step === 0 ? (
          <>
          <Table
              columns={gantonTemplateFlag ? gantonColumns : cambridgeColumns}
              dataSource={
                gantonTemplateFlag ? gantonDataSource : cambridgeDataSource
              }
              pagination={false}
              bordered
            />
            <br />
            {gantonTemplateFlag && (
              <Row>
                <Col span={12}>
                  <Form.Item
                    label='Neck Size'
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 10 }}
                    name={[index, dataIndex, 'neckSize']}
                  >
                    <Space>
                      <InputNumber
                        min={0}
                        value={modalData?.neckSize || alterationFields?.neckSize}
                        onChange={value =>
                          setModalData(pre => ({ ...pre, neckSize: value }))
                        }
                      />
                      <strong>cm</strong>
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row style={{ marginTop: '1rem' }}>
              <Col span={24}>
                <Form.Item
                  label='Comments'
                  labelCol={{ span: 2 }}
                  wrapperCol={{ span: 22 }}
                  name={[index, dataIndex, 'comments']}
                >
                  <Input.TextArea
                    rows={3}
                    value={modalData?.comments || alterationFields?.comments}
                    onChange={e =>
                      setModalData(pre => ({ ...pre, comments: e.target.value }))
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            {errors.length > 0 && (
              <Alert
                style={{ marginTop: '1rem' }}
                type='error'
                message='Please fix the following errors before proceeding:'
                description={
                  <ul style={{ marginBottom: 0 }}>
                    {errors.map((err, i) => (
                      <li key={i}>{err}</li>
                    ))}
                  </ul>
                }
              />
            )}
          </>
        ) : (
          <>
            <p>Please review the alteration details below before confirming.</p>
            <Descriptions bordered column={1} size='small'>
              {reviewItems.map(item => (
                <Descriptions.Item key={item.key} label={item.label}>
                  {item.children}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </>
        )}
      </Modal>
    </>
  )
}

export default AddAlterationsFormModal
